var InMemoryHeadCacheController = /** @class */ (function () {
    function InMemoryHeadCacheController(cache) {
        this.cache = cache || {
            cssUrls: [],
        };
    }
    InMemoryHeadCacheController.prototype.setCssUrl = function (url) {
        var cacheHit = this.cache.cssUrls.includes(url);
        if (cacheHit)
            return false;
        this.cache.cssUrls.push(url);
        return true;
    };
    InMemoryHeadCacheController.prototype.getCssUrls = function () {
        return this.cache.cssUrls;
    };
    InMemoryHeadCacheController.prototype.getCache = function () {
        return this.cache;
    };
    return InMemoryHeadCacheController;
}());
export { InMemoryHeadCacheController };
